import React, { useEffect, useState } from 'react';

// import '@ant-design/compatible/assets/index.css';


import { useQuery } from 'react-query';
import {
  Col,
  DatePicker,
  Row,
  Typography,
  Radio,
  Form,
  Divider,
  Input,
  Space,
  Spin,
} from 'antd';

import DF from 'DisplayFramework';
import { toCurrency } from 'utils/utils';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { getProposalById } from 'services/proposal';
import { FormInstance } from 'antd/lib/form/hooks/useForm';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import AssetDetails from 'pages/Asset/AssetDetail';
import Address from 'components/address';
import AddresseListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/AddressesListSelect';
import Value from 'components/Value';
import ModalControllerNV from 'components/ModalControllerNV';

const { Text } = Typography;

export type TabPropAssetOrderingProps = {
  objectid: number;
  form: FormInstance;
  setSuccessful: any;
};

const TabPropAssetOrdering = ({
  objectid,
  form,
  setSuccessful,
}: TabPropAssetOrderingProps) => {
  const { data, isFetching } = useQuery(
    ['getProposalById', { ctrid: objectid }],
    () => getProposalById({ ctrid: objectid }).then((res) => res.data)
  );

  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  const [deliveryAddress, setDeliveryAddress] = useState('CLIENT');
  const [disabled, setDisabled] = useState(true);
  const [isClient, setisClient] = useState(false);


  const [tppaymodeout, setTppaymodeout] = useState('');
  const [tppaydelayout, setTppaydelayout] = useState('');

  useEffect(() => {
    if (data) {
      changeAdress(deliveryAddress);

      const supplierTp = data.thirdParties.find((tp) => tp.tprolecode === 'SUPPLIER');
      if (supplierTp) {
        setTppaymodeout(supplierTp.tppaymodeout);
        setTppaydelayout(supplierTp.tppaydelayout);
      }

    }
  }, [data]);


  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 7 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 17 },
    },
  };

  const changeAdress = (typeClient: string) => {
    if (typeClient === 'CLIENT' || typeClient === 'SUPPLIER') {
      const thridPartie = data?.thirdParties.find(
        (thridPart) => thridPart.tprolecode === typeClient
      );

      if (typeClient === 'CLIENT') {
        setisClient(true);
      } else {
        setisClient(false);
      }

      setDisabled(true);

      form.setFieldsValue({
        adress: thridPartie?.address?.tpadrid,
        deliveryadrstreet1: thridPartie?.address?.tpmainadrstreet1,
        deliveryadrstreet2: thridPartie?.address?.tpmainadrstreet2,
        deliveryadrzipcode: thridPartie?.address?.tpmainadrzipcode,
        deliveryadrcity: thridPartie?.address?.tpmainadrcity,
        deliveryadrregion: thridPartie?.address?.tpmainadrregion,
        deliveryadrcountry: thridPartie?.address?.tpmainadrcountry,
      });
    } else {
      setDisabled(false);
      form.setFieldsValue({
        deliveryadrstreet1: '',
        deliveryadrstreet2: '',
        deliveryadrzipcode: '',
        deliveryadrcity: '',
        deliveryadrregion: '',
        deliveryadrcountry: '',
      });
    }
    setDeliveryAddress(typeClient);
  };

  return (
    <DF.Provider pagcode="tabpropassetordering">
      <Spin spinning={isFetching}>
        <Form form={form} {...formItemLayout} style={{ textAlign: 'left' }}>
          <Col span={24}>
            <Divider orientation="left">
              <GetLabel label="Ordering" />
            </Divider>
            <div style={{ paddingLeft: 20, paddingRight: 20 }}>
              <Col span={22}>
                <Row gutter={[40, 20]}>
                  <FormInput
                    labelAlign="left"
                    col
                    xs={12}
                    lg={12}
                    name="groupingMode"
                  >
                    <ParListSelect parcode="POGROUP" />
                  </FormInput>
                  <FormInput
                    labelAlign="left"
                    col
                    xs={12}
                    lg={12}
                    name="popaymentmode"
                  >
                    <ParListSelect 
                      parcode="PAYMODEOUT" 
                      forcedValue={tppaymodeout}
                      allowClear
                    />
                  </FormInput>
                </Row>
                <Row gutter={[40, 20]}>
                  <FormInput
                    labelAlign="left"
                    col
                    xs={12}
                    lg={12}
                    name="poexpecteddeliverydate"
                    rules={[{ required: true }]}
                  >
                    <DatePicker />
                  </FormInput>
                  <FormInput
                    labelAlign="left"
                    col
                    xs={12}
                    lg={12}
                    name="popaymentdelay"
                  >
                    <ParListSelect 
                      parcode="PAYDELAYOU" 
                      forcedValue={tppaydelayout}
                      allowClear
                    />
                  </FormInput>
                </Row>
              </Col>
            </div>

            <Divider orientation="left">
              <GetLabel label="Assets" />
            </Divider>
            <div style={{ paddingLeft: 20, paddingRight: 20 }}>
              <Row>
                <Col lg={24} xs={24}>
                  <table
                    className="border"
                    style={{
                      width: '100%',
                      border: '1px solid',
                      textAlign: 'center',
                    }}
                  >
                    <tr
                      className="border"
                      style={{ background: '#EAEAEA', lineHeight: 3 }}
                    >
                      <td className="border">
                        <GetLabel label="Asset" />
                      </td>
                      <td className="border">
                        <GetLabel label="Label" />
                      </td>
                      <td className="border">
                        <GetLabel label="status" />
                      </td>
                      <td className="border">
                        <GetLabel label="quantity" />
                      </td>
                      <td className="border">
                        <GetLabel label="Supplier" />
                      </td>
                      <td className="border">
                        <GetLabel label="netAmount" />
                      </td>
                    </tr>
                    {data?.assets?.map((asset, index) => (
                      <tr
                        key={index}
                        className="border"
                        style={{ background: '#FFF', lineHeight: 3 }}
                      >
                        <td
                          className="border"
                          style={{ color: 'red', fontWeight: 500 }}
                        >
                          <ModalControllerNV
                            content={({ setVisible, visible }) => (
                              <a onClick={() => setVisible(true)}>
                                {asset.assetreference}
                              </a>
                            )}
                            modal={({ setVisible, visible }) => (
                              <AssetDetails
                                hideSaveBtn
                                hideActionBtn
                                asset={asset}
                                onCancel={() => setVisible(false)}
                                showAsModal
                                visible={visible}
                                iscreate={false}
                              />
                            )}
                          ></ModalControllerNV>
                        </td>
                        <td className="border">{asset.assetlabel}</td>
                        <td className="border">{asset.statuslabel}</td>
                        <td className="border" style={{ fontWeight: 500 }}>
                          {asset.assetqty}
                        </td>
                        <td
                          className="border"
                          style={{ color: 'red', fontWeight: 500 }}
                        >
                          {asset.tpidsupplier == null ? (
                            asset.assetComponents.length === 0 ? (
                              <Text type="danger">Not defined</Text>
                            ) : (
                              <Text type="warning">
                                &gt;&gt;&nbsp;Multiple Suppliers
                              </Text>
                            )
                          ) : (
                            <div>
                              <ModalControllerNV
                                content={({ setVisible, visible }) => (
                                  <a
                                    onClick={() => {
                                      setVisible(true);
                                    }}
                                  >
                                    {asset.suppliername}
                                  </a>
                                )}
                                modal={({ setVisible, visible }) => (
                                  <ThirdPartyModal
                                    tpId={asset.tpidsupplier}
                                    visible={visible}
                                    onCancel={() => setVisible(false)}
                                    onSuccess={() => setVisible(false)}
                                    title={asset.suppliername}
                                    iscreate={false}
                                  />
                                )}
                              ></ModalControllerNV>
                            </div>
                          )}
                        </td>
                        <td
                          className="border"
                          style={{ color: 'red', fontWeight: 500 }}
                        >
                          {toCurrency(asset.assetnetamount, asset.currcode)}
                        </td>
                      </tr>
                    ))}
                  </table>
                </Col>
              </Row>
            </div>

            <Divider orientation="left">
              <GetLabel label="DeliveryAddress" />
            </Divider>

            <div style={{ paddingLeft: 20, paddingRight: 20 }}>
              <Row>
                <Col span={isClient ? 3 : 6}>
                  <div>
                    <Radio.Group
                      value={deliveryAddress}
                      onChange={(e) => {
                        changeAdress(e.target.value);
                      }}
                      style={{ marginLeft: 20, padding: 5 }}
                    >
                      <Space direction="vertical">
                        <Radio value="CLIENT">
                          {' '}
                          <GetLabel label="client" />
                        </Radio>
                        <Radio value="SUPPLIER">
                          <GetLabel label="Supplier" />
                        </Radio>
                        <Radio value="NEWADD">
                          <GetLabel label="newAddress" />
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                </Col>
                {isClient && (
                  <Col span={6}>
                    <Row>
                      <FormInput
                        labelAlign="left"
                        col
                        sm={24}
                        md={23}
                        name="adress"
                      >
                        <AddresseListSelect
                          params={{ tpid: data?.tpidclient ?? 0 }}
                          onSelected={(adress) => {
                            form.setFieldsValue({
                              deliveryadrstreet1: adress?.tpmainadrstreet1,
                              deliveryadrstreet2: adress?.tpmainadrstreet2,
                              deliveryadrcountry: adress?.tpmainadrcountry,
                              deliveryadrregion: adress?.tpmainadrregion,
                              deliveryadrcity: adress?.tpmainadrcity,
                              deliveryadrzipcode: adress?.tpmainadrzipcode,
                              adressType: adress?.adrtypelabel,
                            });
                          }}
                        />
                      </FormInput>

                      <FormInput
                        labelAlign="left"
                        col
                        sm={24}
                        md={23}
                        name="adressType"
                      >
                        <Value />
                      </FormInput>
                    </Row>
                  </Col>
                )}
                <Col span={isClient ? 15 : 18}>
                  <div>
                    <Row right-align gutter={[20, 20]}>
                      <FormInput
                        labelAlign="left"
                        col
                        sm={24}
                        md={12}
                        name="deliveryadrstreet1"
                      >
                        <Input disabled={disabled} />
                      </FormInput>

                      <FormInput
                        labelAlign="left"
                        col
                        sm={24}
                        md={12}
                        name="deliveryadrstreet2"
                      >
                        <Input disabled={disabled} />
                      </FormInput>
                    </Row>
                    <Address
                      labelAlign="left"
                      form={form}
                      spanCity={12}
                      spanCountry={12}
                      spanGlobalRegion={12}
                      spanRegion={12}
                      spanZip={12}
                      paysField="deliveryadrcountry"
                      regionField="deliveryadrregion"
                      villeField="deliveryadrcity"
                      codePostalField="deliveryadrzipcode"
                      disabled={disabled}
                      hideRegionGlobal
                    />
                  </div>
                </Col>
              </Row>
            </div>

            {/* <Row>
            <Col span={24}>
              <div style={{ padding: 1, marginLeft: '13px' }} >
                <Radio.Group value={deliveryAdress} onChange={(e) => { setDeliveryAdress(e.target.value) }} style={{ marginLeft: 20, padding: 5 }}>
                  <Radio value='Client'>Client</Radio>
                  <Radio value='Supplier'>Supplier</Radio>
                  <Radio value='newAdress'>New Adress</Radio>
                </Radio.Group>
              </div>
            </Col>
            <Col span={24}>
              <div style={{ paddingLeft: 35, paddingRight: 30, marginTop:25 }} >
                <Row right-align gutter={[20, 20]}>
                  <FormInput labelAlign="left" col sm={24} md={8} name="deliveryadrstreet1" />
                  <FormInput labelAlign="left" col sm={24} md={8} name="deliveryadrstreet2" />
                  <FormInput labelAlign="left" col sm={24} md={8} name="deliveryadrzipcode" />
                </Row>
                <Row right-align gutter={[20, 20]}>
                  <FormInput labelAlign="left" col sm={24} md={8} name="deliveryadrcity" />
                  <FormInput labelAlign="left" col sm={24} md={8} name="deliveryadrregion" />
                  <FormInput labelAlign="left" col sm={24} md={8} name="country" />
                </Row>
              </div>
            </Col>
          </Row> */}
          </Col>
        </Form>
      </Spin>
    </DF.Provider>
  );
};
export default TabPropAssetOrdering;
